export default "__VITE_ASSET__BecXXXGE__"